// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationOutput-cls1_2Nd","cls2":"CitationOutput-cls2_zgq CitationOutput-cls1_2Nd"};